import Vue from 'vue'
import VueRouter from 'vue-router'

import LayoutView from '../views/LayoutView.vue'
import ErrorView from '../views/ErrorView.vue'
import LoginView from '../views/LoginView.vue'
import RedHospitalaria from '../views/RedHospitalariaView.vue'
import Especialidades from '../views/EspecialidadesView.vue'
import MembresiaEstatusQR from '../views/MembresiaEstatusQRView.vue'

import InicioEmpleado from '../views/Empleado/InicioView.vue'

import CobranzaAdmin from '../views/Administrador/CobranzaView.vue'
import MembresiaAdmin from '../views/Administrador/MembresiasView.vue'
import OrdenServicio from '../views/Administrador/OrdenServicioView.vue'
import AtorizadorOT from '../views/Administrador/AutorizadorOrdenServicioView.vue'
import AsistenciaAdmin from '../views/Administrador/VisorAsistenciaView.vue'
import CitasAdm from '../views/Administrador/CitasCierreView.vue'
import UrgenciasAdm from '../views/Administrador/UrgenciasView.vue'
import HistoryActionUsers from '../views/Administrador/HistoryActionsUsersView.vue'
import ColectivosAltas from '../views/Administrador/Colectivo/AltasView.vue'



import AvisoPrivacidadAgente from '../views/avisos/Armando.vue'

import PagoRecibos from '../views/Pagos/PagoRecibosViwe.vue'
import BuscaPago from '../components/Pagos/buscaPagoComponent.vue'
import DetalleRecibo from '../components/Pagos/detallePagoComponent.vue'

import UrgenciasMedicas from '../views/Hospital/UrgenciasView.vue'
import CierreUrgenciasMedicas from '../views/Hospital/CierreUrgenciaView.vue'
import ExclusionesMedicas from '../views/Hospital/ExclusionesView.vue'

import PasesUser from '../views/User/CitasMedicasView.vue'
import HomeUser from '../views/User/InicioView.vue'
import RecibosUser from '../views/User/RecibosView.vue'


//import AgenteCobranzaView from '../views/Agente/CobranzaView.vue'
import AgenteMembresiasView from '../views/Agente/MembresiasView.vue'


import CotizacionesView from '../views/Cotizaciones/InicioView.vue' //por perfil
import Cotizacion from '../views/Cotizaciones/Paso1View.vue'
import CotizacionDetalle from '../views/Cotizaciones/DetalleView.vue'
import CotizacionBene from '../views/Cotizaciones/Paso2View.vue'

import CierreCita from '../views/Medico/CierreCitaView.vue'

// import OfertaPromocional from '../views/Ofertas.vue' // para el dia 03-09-25


import CotizadorExterno from '../views/CotizadorExterno/InicioView.vue'


import DatosContratante from '../components/Solicitud/datosContratante.vue'

import DatosTitular from '../components/Solicitud/datosTitular.vue'

// import UploadColectivo from '../views/Administrador/UploadView.vue'


import RenovacionesProximas from '../views/Administrador/Renovaciones/InicioView.vue'

import RecibosFiscales from '../views/Administrador/Recibos/InicioView.vue'

import DatosFiscales from '../views/Administrador/DatosFiscales/InicioView.vue'
import DatosPlan from '@/components/Solicitud/datosPlan.vue'

import FacturaInterna from '@/views/Administrador/Factura/FacturaInternaView.vue'

Vue.use(VueRouter)

function parseJwt(token) {
  if (!token) return null;
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => `%${('00' + c.charCodeAt(0).toString(16))?.slice(-2)}`)
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Error al decodificar JWT:', e);
    return null;
  }
}

function limpiarStorage() {
  const claves = [
    'id', 'token', 'nombres', 'aPaterno', 'aMaterno', 'email',
    'codAge', 'menu', 'idTarjetaTxt', 'idTarjeta', 'tipoUsuario', 'NombresApaterno', 'tipoUsuario'
  ];
  claves.forEach(k => localStorage.removeItem(k));
}


const routes = [
  {
    path: '/',
    name: 'home',
    component: LayoutView,
  },
  {
    path: '/error',
    name: 'error-view',
    component: ErrorView
  },
  {
    path: '/agenteautorizado/aviso-privacidad',
    name: 'aviso-privacidad',
    component: AvisoPrivacidadAgente
  },
  // {
  //   path: '/ofertas',
  //   name: 'error-view',
  //   component: OfertaPromocional
  // },
  {
    path: '/cotizador',
    name: 'cotizador',
    component: CotizadorExterno
  },
  {
    path: '/especialidades-medicas',
    name: 'especialidades-medicas',
    component: Especialidades
  },
  {
    path: "/valida-membresia/:guid?",
    name: "valida-membresia",
    meta: { layout: false, requiresAuth: false },
    component: MembresiaEstatusQR,
    props: route => ({
      guid: route.params.guid || route.query.guid || null
    })
  },
  // {
  //   path: '/uploadcolectivo',
  //   name: 'especialidades-medicas',
  //   component: UploadColectivo
  // },
  {
    path: '/login-colaborador',
    name: 'login-colaborador',
    component: LoginView,
    meta: { layout: false, tipo: 'colaborador' }
  },
  {
    path: '/login-cliente',
    name: 'login-cliente',
    component: LoginView,
    meta: { layout: false, tipo: 'cliente' }
  },
  {
    path: '/login-hospital',
    name: 'login-hospital',
    component: LoginView,
    meta: { layout: false, tipo: 'hospital' }
  },
  {
    path: '/login-medico',
    name: 'login-medico',
    component: LoginView,
    meta: { layout: false, tipo: 'medico' }
  },
  {
    path: '/login-agente',
    name: 'login-agente',
    component: LoginView,
    meta: { layout: false, tipo: 'agente' }
  },
  {
    path: "/sys/acciones",
    name: "sys/acciones",
    props: true,
    meta: { layout: true, requiresAuth: true, title: '', tipo: 'colaborador' },
    component: HistoryActionUsers
  },
  {
    path: "/sys/facturacion-especial",
    name: "sys/facturacion-especial",
    props: true,
    meta: { layout: true, requiresAuth: true, title: '', tipo: 'colaborador' },
    component: FacturaInterna
  },
  {
    path: "/colectivo/altas",
    name: "/colectivo/altas",
    props: true,
    meta: { layout: true, requiresAuth: true, title: '', tipo: 'colaborador' },
    component: ColectivosAltas
  },
  {
    path: "/dashboard/citas",
    name: "dashboard/citas",
    props: true,
    meta: { layout: true, requiresAuth: true, title: '', tipo: 'colaborador' },
    component: CitasAdm
  },
  {
    path: "/dashboard/urgencias",
    name: "dashboard/urgencias",
    props: true,
    meta: { layout: true, requiresAuth: true, title: '', tipo: 'colaborador' },
    component: UrgenciasAdm
  },
  {
    path: "/dashboard/recibosFiscales",
    name: "dashboard/recibosFiscales",
    props: true,
    meta: { layout: true, requiresAuth: true, title: '', tipo: 'colaborador' },
    component: RecibosFiscales
  },
  {
    path: "/dashboard/datosFiscales",
    name: "dashboard/datosFiscales",
    props: true,
    meta: { layout: true, requiresAuth: true, title: '', tipo: 'colaborador' },
    component: DatosFiscales
  },
  {
    path: "/red-hospitalaria",
    name: "red-hospitalaria",
    meta: {
      title: 'Red hospitalaria'
    },
    component: RedHospitalaria
  },
  {
    path: "/hospital/urgencias-medicas/:mem?",
    name: "hospital/urgencias-medicas",
    meta: { layout: true, requiresAuth: true, tipo: 'hospital' },
    component: UrgenciasMedicas
  },
  {
    path: "/hospital/cierre-urgencia:folio?",
    name: "hospital/cierre-urgencia",
    meta: { layout: true, requiresAuth: true, tipo: 'hospital' },
    component: CierreUrgenciasMedicas
  },
  {
    path: "/hospital/exclusiones",
    name: "hospital/exclusiones-medicas",
    meta: { layout: true, requiresAuth: true, tipo: 'hospital' },
    component: ExclusionesMedicas
  },
  {
    path: "/medico/cierre-cita/:cita?",
    name: "medico/cierre-cita",
    props: true,
    meta: { layout: false, requiresAuth: false },
    component: CierreCita
  },
  {
    path: '/pagoenlinea/:recibo?',
    component: PagoRecibos, // este es el layout base
    meta: { layout: false, requiresAuth: false, title: 'Inicio colaborador' },
    children: [
      {
        path: '', // equivale a '/pagar-recibos'
        name: 'buscapago',
        component: BuscaPago // componente principal
      },

      {
        path: 'detalle/:id', // '/pagar-recibos/detalle/123'
        name: 'detalleRecibo',
        component: DetalleRecibo,
        props: route => ({ recibo: route.params.recibo })
      },
    ]
  },
  {
    path: "/solicitud",
    component: () => import("@/views/Administrador/Solicitud/SolicitudView.vue"), // layout general
    meta: { layout: false, requiresAuth: false, title: 'Solicitud MediCover' },
    children: [
      { path: "paso-1", component: DatosContratante },
      { path: "paso-2", component: DatosTitular },
      { path: "paso-3", component: DatosPlan }
      // { path: "paso-3", component: Paso3 },
    ],
  },
  {
    path: '/colaborador',
    name: 'colaborador',
    meta: { layout: true, requiresAuth: true, title: 'Inicio colaborador', tipo: 'colaborador' },
    component: InicioEmpleado,
  },
  {
    path: '/cobranza/:mem?',
    name: 'cobranza',
    props: {
      tipo: "administrador"
    },
    component: CobranzaAdmin,
    meta: { layout: true, requiresAuth: true }
  },
  {
    path: '/visor-membresias/:mem?',
    name: 'visor-membresias',
    props: true,
    component: MembresiaAdmin,
    meta: { layout: true, requiresAuth: true }
  },
  {
    path: '/visor-asistencia',
    name: 'visor-asistencia',
    props: true,
    component: AsistenciaAdmin,
    meta: { layout: true, requiresAuth: true }
  },
  {
    path: '/orden-servicio/:id?', //NUEVO
    name: 'orden-servicio',
    props: true,
    component: OrdenServicio,
    meta: { layout: true, requiresAuth: true } //, tipo: 'colaborador'
  },
  {
    path: '/autorizador-ordenes-servicio/:id?',
    name: 'autorizador-ordenes-servicio',
    props: true,
    component: AtorizadorOT,
    meta: { layout: true, requiresAuth: true }
  },
  {
    path: "/agente/cobranza",
    name: "agente/cobranza",
        props: {
      tipo: "agente"
    },
    meta: { layout: true, requiresAuth: true, title: '', tipo: 'agente' },
    component: CobranzaAdmin
  },
  {
    path: "/agente/cotizaciones",
    name: "agente/cotizaciones",
    props: true,
    meta: { layout: true, requiresAuth: true, title: '' },
    component: CotizacionesView
  },
  {
    path: "/cotizacion/:guid?",
    // props: true,
    name: "cotizacion",
    meta: { layout: true, requiresAuth: true, title: '' },
    component: Cotizacion,
  },
  {
    path: "/cotizacion-detalle/:guid",
    name: "cotizacion-detalle",
    meta: { layout: true, requiresAuth: true, title: '' },
    component: CotizacionDetalle
  },
  {
    path: "/cotizacion-beneficiarios/:guid",
    name: "cotizacion-benef",
    meta: { layout: true, requiresAuth: true, title: '' },
    component: CotizacionBene
  },
  {
    path: "/agente/membresias",
    name: "agente/membresias",
    props: true,
    meta: { layout: true, requiresAuth: true, title: '', tipo: 'agente' },
    component: AgenteMembresiasView
  },
  {
    path: "/user/micuenta",
    name: "user/micuenta",
    props: true,
    meta: { layout: true, requiresAuth: true, title: 'Usuario inicio sesión', tipo: 'cliente' },
    component: HomeUser
  },
  {
    path: "/user/recibos",
    name: "user/recibos",
    props: true,
    meta: { layout: true, requiresAuth: true, title: 'Mis recibos de pago', tipo: 'cliente' },
    component: RecibosUser
  },
  {
    path: "/user/pases",
    name: "user/pases",
    props: true,
    meta: { layout: true, requiresAuth: true, title: 'Mis pases médicos', tipo: 'cliente' },
    component: PasesUser
  },
  {
    path: "/renovaciones/proximas",
    name: "renovaciones/proximas",
    props: true,
    meta: { layout: true, requiresAuth: true, title: 'Mis pases médicos', tipo: 'cliente' },
    component: RenovacionesProximas
  },
  {
    path: '*', // Ruta comodín al final
    name: 'Error',
    component: ErrorView
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/', //process.env.VUE_APP_BASE_URL,
  routes
})

const defaultTitle = 'Medicover'

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || defaultTitle;

  // 🚪 Ruta explícitamente pública
  if (to.matched.some(record => record.meta.requiresAuth === false)) {
    return next();
  }

  // 🔒 Ruta que sí requiere auth
  const requiereAuth = to.matched.some(
    record => record.meta.requiresAuth === true
  );

  if (requiereAuth) {
    const token = localStorage.getItem('token');
    let tipoUsuario = localStorage.getItem('tipoUsuario');

    if (!token) {
      if (!tipoUsuario && to.meta.tipo) {
        tipoUsuario = to.meta.tipo;
      }
      return redirigirAlLogin(tipoUsuario, to, from, next);
    }

    const payload = parseJwt(token);
    if (!payload || payload.exp < Date.now() / 1000) {
      limpiarStorage();
      if (!tipoUsuario && to.meta.tipo) {
        tipoUsuario = to.meta.tipo;
      }
      return redirigirAlLogin(tipoUsuario, to, from, next);
    }
  }

  // Evitar loop innecesario
  if (from.name && to.fullPath === from.fullPath) {
    return next();
  }

  next();
});



function redirigirAlLogin(tipoUsuario, to, from, next) {
  // Definir login por tipo
  const loginPaths = {
    colaborador: '/login-colaborador',
    cliente: '/login-cliente',
    hospital: '/login-hospital',
    medico: '/login-medico',
    agente: '/login-agente'
  };

  const destinoLogin = loginPaths[tipoUsuario] || '/login-cliente';

  // Si ya estamos en el login correcto, no redirigir otra vez
  if (to.path === destinoLogin) {
    return next();
  }

  // Si la navegación ya viene desde el login correcto, evitar bucle
  if (from.path === destinoLogin) {
    return next();
  }

  // Redirigir con query redirect
  next({
    path: destinoLogin,
    query: { redirect: to.fullPath }
  });
}

export default router;
